<template>
  <div class="row" style="height: 100%">
    <Sidebar :disabled="sidebarDisabled"/>
    <ResultPage :sharedTest="sharedTest" @beforeRender="beforeRender" @afterRender="afterRender"/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Sidebar from './Sidebar.vue'
import ResultPage from './ResultPage.vue'
export default {
  components: {
    Sidebar,
    ResultPage
  },
  data: () => ({
    sidebarDisabled: false
  }),
  computed: {
    ...mapState({
      sharedTest: state => state.test.sharedTest.item
    })
  },
  methods: {
    ...mapActions('test', ['clearTestProfile']),
    beforeRender () {
      this.sidebarDisabled = true
    },
    afterRender () {
      this.sidebarDisabled = false
    }
  },
  mounted () {
    this.clearTestProfile()
  }
}
</script>

<style>
.page-container {
  padding: 0.5rem 0 0.5rem;
  overflow-y: scroll;
  overflow-x: hidden;
  margin: 2px 0 2px;
}
.page-content {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/ShowMore.vue